
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1915_1645)"}},[_c('path',{attrs:{"d":"M10.5 6.5v5H0V2h6v1H1v7.5h8.5v-4h1zm1.5-6H6.506l2.018 2-3.489 3.535 1.414 1.414 3.489-3.535L12 6V.5z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1915_1645"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    